// third-party
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';

// project import
import reducers from './reducers';
import { injectStore } from '../utils/axios';

// ==============================|| REDUX TOOLKIT - MAIN STORE ||============================== //

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('analytics_filter', serializedState);
  } catch (err) {
    console.error(err);
  }
};

const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

store.subscribe(() => {
  saveState({
    analytics: store.getState().analytics,
  });
});

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

injectStore(store);

export { store, dispatch, useSelector, useDispatch };
